export default "__VITE_ASSET__BTNyPv7i__"